import type { TargetMarketFieldProps } from './TargetMarketField.types'
import { TargetMarketSelect } from './TargetMarketSelect'

export function TargetMarketField({
  id,
  catalog,
  isLoading,
  isError,
  value,
  onValueChange,
  disabled,
  error,
  unavailableLabel = 'Could not load target markets.',
}: TargetMarketFieldProps) {
  if (catalog) {
    return (
      <TargetMarketSelect
        id={id}
        catalog={catalog}
        value={value}
        onValueChange={onValueChange}
        disabled={disabled}
        error={error}
      />
    )
  }

  return (
    <p className="rounded-lg border border-input bg-muted/40 px-3 py-3 text-sm text-muted-foreground">
      {isLoading && !isError ? 'Loading target markets…' : unavailableLabel}
    </p>
  )
}
